import React, { lazy } from 'react';
import { CarFront, Wrench, Car, Truck, DoorOpen, PhoneCall, ArrowRight, ShieldCheck } from 'lucide-react';
export function Services() {
  const services = [{
    icon: CarFront,
    title: 'Emergency Windshield Replacement',
    copy: "For cracked, shattered or unsafe windshields, Kosin's Glass provides professional windshield replacement with certified technicians and quality glass options."
  }, {
    icon: Wrench,
    title: 'Broken Windshield Repair Today',
    copy: "Small chips may be repairable before they spread. Kosin's Glass can inspect the damage and explain whether chip repair or replacement is safer."
  }, {
    icon: Car,
    title: 'Shattered Side Window Replacement',
    copy: 'Driver side, passenger side and power window glass replacement for broken or shattered side windows.'
  }, {
    icon: CarFront,
    title: 'Rear Window Replacement',
    copy: 'Replacement for broken rear vehicle glass, back windows, truck rear glass and other damaged rear window glass.'
  }, {
    icon: DoorOpen,
    title: 'Car Door & Quarter Glass',
    copy: 'Replacement for car door glass, quarter glass, vent glass and other urgent vehicle glass damage.'
  }, {
    icon: Truck,
    title: 'Truck, Van, Fleet & Semi Glass',
    copy: 'Urgent glass repair and replacement options for trucks, vans, commercial vehicles, fleets and semi trucks.'
  }];
  return <section className="py-16 md:py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-1085" data-mp="8tf50hy2u3qk">
      <div className="max-w-7xl mx-auto" data-id="element-1086" data-mp="8v8fk8bt983u">
        {/* Image + intro */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center mb-14" data-id="element-1087" data-mp="3uu74p6arw5a">
          <div className="relative" data-id="element-1088" data-mp="3vz6err572v3o">
            <div className="rounded-lg overflow-hidden shadow-lg border border-slate-200 aspect-[4/3]" data-id="element-1089" data-mp="3w07qzyxy5nmz">
              <img src="https://cdn.magicpatterns.com/uploads/iwR2zxogSUd82yEgZeaCw8/Emergency_Auto.png" alt="Kosin's Glass technician carefully inspecting a cracked windshield with a flashlight before recommending repair or replacement" className="w-full h-full object-cover" loading="lazy" data-id="element-1090" data-mp="1y5qz24wzz9b0" />
            </div>
            <div className="hidden sm:flex absolute -bottom-5 -right-5 bg-white border border-slate-200 shadow-md rounded-lg px-4 py-3 items-center gap-3" data-id="element-1091" data-mp="3emg305ihk8zc">
              <div className="bg-emergencyBrand-redLight p-2 rounded-lg" data-id="element-1092" data-mp="abdub7w017w4">
                <ShieldCheck className="w-5 h-5 text-emergencyBrand-red" data-id="element-1093" data-mp="f9xhtcq8qrql" />
              </div>
              <div data-id="element-1094" data-mp="19wdtoeoj46w">
                <div className="text-xs font-semibold text-slate-500 uppercase tracking-wide" data-id="element-1095" data-mp="1afpwohneyd0">
                  Certified
                </div>
                <div className="text-sm font-bold text-slate-900" data-id="element-1096" data-mp="6atv7yrv7u7c">
                  Auto Glass Technicians
                </div>
              </div>
            </div>
          </div>
          <div data-id="element-1097" data-mp="2r0j9oaonpdzi">
            <div className="inline-flex items-center gap-2 bg-emergencyBrand-redLight text-emergencyBrand-red px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-normal mb-5 border border-emergencyBrand-redBorder" data-id="element-1098" data-mp="2qwvgxdr1cvlu">
              <span className="w-1.5 h-1.5 rounded-full bg-emergencyBrand-red" data-id="element-1099" data-mp="2sfvgi5y5gi82" />
              Emergency Auto Glass
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-slate-900 mb-5 tracking-normal leading-tight" data-id="element-1100" data-mp="2ni2bvhchvw9w">
              <span className="text-emergencyBrand-red" data-id="element-1101" data-mp="1zrpulfvd0n6n">
                Auto Glass Services
              </span>{' '}
              for Broken Vehicle Glass
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed" data-id="element-1102" data-mp="29iaztm5jgpyj">
              When vehicle glass breaks you need clear answers fast. Kosin's
              Glass can inspect the damage, explain whether repair or
              replacement is needed, and help schedule the fastest available
              option.
            </p>
          </div>
        </div>
        {/* Service cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-10" data-id="element-1103" data-mp="fb9x2bpoc9gf">
          {services.map((service, i) => <div key={i} className="bg-white rounded-lg p-6 border border-slate-200 hover:border-emergencyBrand-red/40 hover:shadow-md transition-all" data-id="element-1104" data-mp="ka38lylehqdy" data-mpi={i}>
              <div className="w-12 h-12 bg-emergencyBrand-redLight rounded-lg flex items-center justify-center mb-5" data-id="element-1105" data-mp="t3gbntd6i8dr">
                <service.icon className="w-6 h-6 text-emergencyBrand-red" data-id="element-1106" data-mp="y32ow2t0bomk" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-1107" data-mp="12y8b72qbn5b6">
                {service.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-1108" data-mp="17xbheqi1fhkq">{service.copy}</p>
            </div>)}
        </div>
        <div className="text-center" data-id="element-1109" data-mp="39qsnhpqisadd">
          <a href="tel:517-545-7772" className="inline-flex items-center justify-center gap-2 bg-emergencyBrand-red hover:bg-emergencyBrand-redHover text-white px-7 py-4 rounded-lg font-bold text-base transition-colors shadow-sm" data-id="element-1110" data-mp="39ru5ke5ydx4l">
            <PhoneCall className="w-5 h-5" data-id="element-1111" data-mp="31hd1lan4oq9y" />
            Check Today's Auto Glass Openings
            <ArrowRight className="w-4 h-4" data-id="element-1112" data-mp="2wiiis8p5v1pu" />
          </a>
        </div>
      </div>
    </section>;
}